import Styled from 'styled-components';

import { Card } from '../../Card/';

const KBACard = Styled(Card)`
  padding: 2em;
`;

KBACard.displayName = 'KBACard';

export default KBACard;
